export default {
  api: 'https://api.eyeson.team',
  youtube: { key: '', client: '' },
  allowSafariSFU: true,
  screencapture: true
};
